import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { uGetTimeArray } from '@appbase/util';

@Component({

})
export default class TimeLine  extends Vue {
    timeArray: reserve.TimelineItem[] = [];

    created() {
        this.timeArray = uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString()
        ]);              
    }

    getTimelineText(item: reserve.TimelineItem): string {
        if(item.num == 0) {
            return `12 ${this.$t('오전')}`
        } else if(item.num > 12) {
            return `${item.num - 12} ${this.$t('오후')}`
        } else {
            return `${item.num} ${this.$t('오전')}`
        }
    }
}